import React, { useEffect } from "react";
import styled from "styled-components";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

//svgs
import {
  Time as TimeIcon,
  VoiceIcon,
  Location,
  Calender,
} from "../../../components/svgs";
import {
  StyledText,
  MainHolder,
  Children,
  Body,
  DynamicButton,
} from "../../../components/common/basic";
import { BackButton, FeatureHeader } from "../../../components/common";
import useYPYC from "./hooks/useYPYC";

const iconMap = {
  time: TimeIcon,
  calendar: Calender,
  location: Location,
  edit: VoiceIcon,
};

const YPYCHome = () => {
  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "YPYCRegistrationHome",
        firebase_screen_class: "YPYCRegistrationHome",
      })
    );
  }, []);

  const {
    background,
    history,
    bannerImage,
    registrationDetails,
    ypycRegistrationStatus,
  } = useYPYC();

  return (
    <>
      <MainHolder>
        <Children>
          <BackButton onClick={() => history.goBack()} />
          <FeatureHeader
            image={bannerImage}
            title={["YPYC Transform", "Summit 2024"]}
            background={"#fff"}
            secondaryBackground={"#fff"}
          ></FeatureHeader>

          <Body>
            <div
              style={{
                boxSizing: "border-box",
                padding: "10px 15px 70px 15px",
              }}
            >
              {registrationDetails?.points.map(
                ({ icon, title, description }) => (
                  <IconList
                    Icon={iconMap[icon]}
                    title={title}
                    description={description}
                    color={background}
                  />
                )
              )}
              <HorizontalLine />

              <div>
                <StyledText
                  size={14}
                  style={{ fontFamily: "MTNMedium", margin: "0 0 4px 0" }}
                >
                  About the event
                </StyledText>
                <StyledText
                  size={12}
                  style={{ fontFamily: "MTNRegular", margin: "0 0 10px 0" }}
                >
                  <span style={{ fontFamily: "MTNMedium" }}>Theme:</span> 15 years of transformational leadership
                </StyledText>

                <StyledText
                  size={12}
                  style={{ fontFamily: "MTNMedium", margin: "0 0 10px 0" }}
                >
                  Benefits
                </StyledText>
                <ol
                  style={{
                    fontFamily: "MTNRegular",
                    padding: 0,
                    margin: "0 0 0 15px",
                    fontSize: "12px",
                  }}
                >
                  {registrationDetails.benefits.map((benefit) => (
                    <li>
                      <StyledText
                        size={12}
                        style={{
                          fontFamily: "MTNRegular",
                          margin: "0 0 10px 0",
                        }}
                      >
                        {benefit}
                      </StyledText>
                    </li>
                  ))}
                </ol>
                <StyledText
                  size={12}
                  style={{ fontFamily: "MTNRegular", margin: "20px 0 20px 0" }}
                >
                  <span style={{ fontFamily: "MTNMedium" }}>
                    Media partners:
                  </span>{" "}
                  GTV, Joy News, TV3, UTV, The inquisitor, LuvTouch, Hello FM
                </StyledText>
              </div>

              {/* <img
                src={tailImage}
                style={{ width: "100%" }}
                alt='Media Partner logos'
              /> */}

              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  background: "#fff",
                  borderTop: "1px solid #ddd",
                }}
              >
                <div style={{ padding: "10px 30px" }}>
                  <DynamicButton
                    onClick={() => {
                      if (ypycRegistrationStatus === false)
                        history.push("/ypycregistration/register");
                      // history.push("/loyalty/livestream");
                    }}
                    label={
                      ypycRegistrationStatus === null
                        ? "Checking registration status..."
                        : ypycRegistrationStatus === false
                          ? "Register"
                          : "You are registered!"
                      // "Watch Live"
                    }
                    disabled={ypycRegistrationStatus === null}
                    color={
                      ypycRegistrationStatus === false ? background : "#0FAF4B"
                      // "#0FAF4B"
                    }
                    fullWidth
                  />
                </div>
              </div>
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const IconList = ({ Icon, title, description, color }) => (
  <div style={{ display: "flex", alignItems: "top", marginBottom: "15px" }}>
    <div
      style={{
        width: "16px",
        marginRight: "10px",
      }}
    >
      <Icon fill={color} width={16} height={16} />
    </div>
    <div>
      <StyledText
        size={14}
        style={{ fontFamily: "MTNBold", margin: "0 0 2px 0" }}
      >
        {title}
      </StyledText>
      <StyledText size={12} style={{ fontFamily: "MTNRegular", margin: "0" }}>
        {description}
      </StyledText>
    </div>
  </div>
);

const HorizontalLine = styled.div`
  margin: 20px 0;
  border-top: none;
  border-bottom: 1px solid #ddd;
`;

export default YPYCHome;
